/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type NotificationSettingsContent_intervalValues$ref: FragmentReference;
declare export opaque type NotificationSettingsContent_intervalValues$fragmentType: NotificationSettingsContent_intervalValues$ref;
export type NotificationSettingsContent_intervalValues = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: NotificationSettingsContent_intervalValues$ref,
|};
export type NotificationSettingsContent_intervalValues$data = NotificationSettingsContent_intervalValues;
export type NotificationSettingsContent_intervalValues$key = {
  +$data?: NotificationSettingsContent_intervalValues$data,
  +$fragmentRefs: NotificationSettingsContent_intervalValues$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "NotificationSettingsContent_intervalValues",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '329b4cd66c302e8c516541697542498b';
module.exports = node;
